# String methods

if typeof String.prototype.upcaseFirst is 'undefined'
  Object.defineProperty String.prototype, 'upcaseFirst', value: -> @.replace /^(.)/, (_, char) => char.toUpperCase()

if typeof String.prototype.downcaseFirst is 'undefined'
  Object.defineProperty String.prototype, 'downcaseFirst', value: -> @.replace /^(.)/, (_, char) => char.toLowerCase()

if typeof String.prototype.titleize is'undefined'
  Object.defineProperty String.prototype, 'titleize', value: ->
    @.replaceAll(/(^|_)(.)/g, (_, prec, char) => (if prec then ' ' else '') + char.toUpperCase()).
      replaceAll(/([\w])([A-Z])/g, (first, prec, char) => prec + ' ' + char)

if typeof String.prototype.camelize is 'undefined'
  Object.defineProperty String.prototype, 'camelize', value: -> @.replaceAll /_(.)/g, (_, char) => char.toUpperCase()

if typeof String.prototype.underscore is'undefined'
  Object.defineProperty String.prototype, 'underscore', value: -> @.replaceAll /[A-Z]/g, (char) => '_' + char.toLowerCase()

if typeof String.prototype.compare is'undefined'
  Object.defineProperty String.prototype, 'compare', value: (string) ->
    splitNumbers = /[^0-9]+|[0-9]+/gu
    splitThis = this.match(splitNumbers)
    splitString = string.match(splitNumbers)
    index = splitThis.findIndex (subString, index) => subString.localeCompare(splitString[index])
    if index is -1 then 0 else
      if index % 2 then splitThis[index] - splitString[index] else splitThis[index].localeCompare(splitString[index])
